module.exports = __webpack_public_path__ + "media/basic-details/meetup@2x-5f88cb91.png";